export const PaymentIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <g>
      <path
        d='M0.799805 8.495V13.9537C0.799805 15.5257 1.91143 16.8 3.28272 16.8H16.7169C18.0882 16.8 19.1998 15.5257 19.1998 13.9537V8.495C19.1998 8.22164 19.0065 8 18.768 8H1.23162C0.993148 8 0.799805 8.22164 0.799805 8.495ZM5.39381 11.96H4.24232C3.82497 11.96 3.48664 11.5722 3.48664 11.0938C3.48664 10.6153 3.82497 10.2275 4.24232 10.2275H5.39381C5.81116 10.2275 6.14948 10.6153 6.14948 11.0938C6.14948 11.5722 5.81116 11.96 5.39381 11.96Z'
        fill='currentColor'
      />
      <path
        d='M19.1998 5.94922V5.78673C19.1998 4.35767 18.0882 3.19922 16.7169 3.19922H3.28272C1.91143 3.19922 0.799805 4.35767 0.799805 5.78673V5.94922C0.799805 6.19773 0.993148 6.39922 1.23162 6.39922H18.768C19.0065 6.39922 19.1998 6.19773 19.1998 5.94922Z'
        fill='currentColor'
      />
    </g>
  </svg>
)
